import { render, staticRenderFns } from "./MembershipPlan.vue?vue&type=template&id=36813a70&scoped=true&"
import script from "./MembershipPlan.vue?vue&type=script&lang=js&"
export * from "./MembershipPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36813a70",
  null
  
)

export default component.exports